/**
 * Created by mqamhieh on 10/5/17.
 */
window.SendCEBAssessmentForm = function(scope, brandId, jobId) {
    var self = this;
    var formName = "send-ceb-assessment-form";
    var _protected = BaseForm.call(self, formName, scope);

    self.data['message'] = "Dear [Applicant Name],\n" +
        "\n" +
        "As part of our [Position Name] screening process, we would like you to complete a talent/personality assessment. Please find a link to the assessment tests below:\n" +
        "[Links]\n" +
        "\n" +
        "Looking forward to proceeding with your application!\n" +
        "\n" +
        "Sincerely,\n" +
        "[Employer Name]";

    self.load = function (userId, applicationId) {
        var defer = $q.defer();

        self.applicationId = applicationId;

        UserAPI.getUserBasicDetails(userId)
            .then(function(userDetails) {
                self.data['user'] = userDetails;
                defer.resolve();
                scope.$digest();
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.save = function () {
        var defer = $q.defer();

        TalentAssessmentAPI.registerForAssessment(brandId, jobId, self.applicationId, self.data['message'])
            .then(function (data) {
                defer.resolve(data);
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };
};